import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const [searchText, setSearchText] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchText.trim()) {
      navigate(`/category/all?search=${encodeURIComponent(searchText.trim())}`);
    }
  };

  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20Korean%20manhwa%20webtoon%20art%20background%20with%20warm%20coral%20and%20amber%20gradients%2C%20flowing%20artistic%20comic%20panel%20lines%2C%20soft%20geometric%20shapes%2C%20modern%20minimalist%20style%2C%20subtle%20texture%2C%20dark%20moody%20atmosphere%20with%20warm%20highlights%2C%20cinematic%20composition%2C%20no%20text%2C%20abstract%20illustration&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt="韩漫之家 - 免费韩漫在线观看"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

      <div className="relative z-10 w-full max-w-3xl mx-auto px-4 text-center">
        <h1 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-4 leading-tight">
          免费韩漫在线观看平台
        </h1>
        <p className="text-background-50/80 text-sm md:text-base mb-8 max-w-xl mx-auto leading-relaxed">
          海量下拉式韩漫大全，随时随地畅读热门韩国漫画。
          <br className="hidden md:block" />
          流畅浏览体验，轻松追更最新章节，发现您的下一部心头好。
        </p>

        <form onSubmit={handleSearch} className="flex items-center max-w-lg mx-auto bg-background-50 rounded-full overflow-hidden shadow-lg">
          <div className="w-12 h-12 flex items-center justify-center flex-shrink-0">
            <i className="ri-search-line text-foreground-400 text-lg"></i>
          </div>
          <input
            type="text"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="搜索你喜欢的韩漫..."
            className="flex-1 py-3 pr-4 text-sm text-foreground-950 placeholder:text-foreground-400 bg-transparent focus:outline-none"
          />
          <button
            type="submit"
            className="px-6 py-3 bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            搜索
          </button>
        </form>

        <div className="flex items-center justify-center gap-6 mt-8">
          {[
            { icon: 'ri-fire-line', label: '16部', sub: '热门作品' },
            { icon: 'ri-user-heart-line', label: '50万+', sub: '忠实读者' },
            { icon: 'ri-bookmark-line', label: '日更', sub: '持续追更' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-8 h-8 mx-auto flex items-center justify-center mb-1">
                <i className={`${stat.icon} text-background-50/80 text-lg`}></i>
              </div>
              <p className="text-background-50 font-bold text-lg">{stat.label}</p>
              <p className="text-background-50/60 text-xs">{stat.sub}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}